module.exports = __webpack_public_path__ + "img/img15.2d126f49.svg";